import { tv } from '@change/ds-utils';

/**
 * Styles for CompletedTask checkbox wrapper
 *
 * Why we need a wrapper div with descendant selectors:
 * - The design system's BaseCheckbox hardcodes internal sizes (h-4 w-4 for indicator, 14x14 for SVG, gap-2)
 * - We cannot modify the design system component directly
 * - React Aria's className prop on Checkbox only affects the <label> element, not its descendants
 * - Therefore, we must use a wrapper div with descendant selectors to override internal structure
 *
 * Note: CompletedTask always has isSelected=true (checkbox is always checked and read-only)
 */
export const completedTaskStyles = tv({
	slots: {
		checkboxWrapper: [
			// Base layout styles
			'flex items-start md:items-center',

			// Override Checkbox label gap (design system default: gap-2)
			// Targets: <label data-rac="">
			'[&_[data-rac]]:gap-4 md:[&_[data-rac]]:gap-5',

			// Override checkbox label alignment (design system default: self-start)
			'md:[&_[data-rac]_div:first-of-type]:self-center',
		],
	},
});
